import {
  HIDE_ALL_PANELS,
  HIDE_PANEL,
  SHOW_PANEL,
  UPDATE_INDIVIDUAL
} from '@/store/actions/panels'

const state = {
  queryParams: {
    search: '',
    project: '',
    analysis: '',
    bioModel: '',
    submission: ''
  },
  panelsVisibility: {
    search: false,
    project: false,
    analysis: false,
    bioModel: false,
    submission: false
  },
  isProjectPanelMaximized: true,
  individual: ''
}

const getters = {
  panels: state => state.panelsVisibility,
  searchText: state => String(state.queryParams.search),
  projectId: state => String(state.queryParams.project),
  analysisId: state => String(state.queryParams.analysis),
  bioModelId: state => String(state.queryParams.bioModel),
  submissionId: state => String(state.queryParams.submission),
  individualId: state => String(state.individual),
  isProjectPanelMaximized: state => state.isProjectPanelMaximized,
  query: state => state.queryParams,
  areAllPanelsHidden: state => Object
    .values(state.panelsVisibility)
    .every(panel => !panel)
}

const mutations = {
  setQueryParams: (state, queryParams) => {
    state.queryParams = {
      ...state.queryParams,
      ...queryParams
    }
  },
  setPanelsVisibility: (state, panelsVisibility) => {
    state.panelsVisibility = {
      ...state.panelsVisibility,
      ...panelsVisibility
    }
  },
  maximizeProject: (state) => {
    state.isProjectPanelMaximized = true
  },
  minimizeProject: (state) => {
    state.isProjectPanelMaximized = false
  },
  [UPDATE_INDIVIDUAL]: (state, individualId) => {
    state.individual = individualId
  }
}

const actions = {
  [HIDE_PANEL] (context, model) {
    let panels = {
      [model]: '',
      ...(model === 'project') ? { 'submission': '' } : {}
    }
    context.commit('setPanelsVisibility', panels)
    context.commit('setQueryParams', panels)
  },
  [SHOW_PANEL] (context, panels) {
    context.commit('setPanelsVisibility', panels)
    context.commit('setQueryParams', panels)
  },
  [HIDE_ALL_PANELS] (context) {
    context.commit('setPanelsVisibility', {
      search: false,
      project: false,
      analysis: false,
      bioModel: false,
      submission: false
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
